import React from 'react'; // TODO

var FormContext = React.createContext({
  controlId: undefined
});
export default FormContext;